import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M6 5.25A3.75 3.75 0 0 0 2.25 9v7A3.75 3.75 0 0 0 6 19.75h7a3.75 3.75 0 0 0 3.75-3.7l2.332 1.438a1.75 1.75 0 0 0 2.668-1.49V9.002a1.75 1.75 0 0 0-2.668-1.49L16.75 8.949A3.75 3.75 0 0 0 13 5.25zm10.75 5.461v3.578l3.119 1.922a.25.25 0 0 0 .381-.213V9.002a.25.25 0 0 0-.381-.213zM15.25 9A2.25 2.25 0 0 0 13 6.75H6A2.25 2.25 0 0 0 3.75 9v7A2.25 2.25 0 0 0 6 18.25h7A2.25 2.25 0 0 0 15.25 16z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }